import { z } from 'zod';
import {
    CursorPaginationSchema,
    OpaqueCursorPaginationSchema,
    type OpaqueCursorPagination,
} from './authorization.types';
import type {
    CursorSearchRequest,
    OpaqueCursorSearchRequest,
} from './omnisearch.types';
import {
    UserProfileDetailedPublicResponseSchema,
    UserProfileDetailedResponseSchema,
} from './schemas/user.schemas';
import type { UserProfileDetailedPublicResponse } from './user.types';

export interface UserListingSearchRequest extends CursorSearchRequest {
    show_deleted?: boolean;
}

export interface PublicUserListingSearchRequest extends OpaqueCursorSearchRequest {
    show_deleted?: boolean;
}

export const UserListingPageResponseSchema = z.object({
    users: z.array(UserProfileDetailedResponseSchema),
    pagination: CursorPaginationSchema,
});

export type UserListingPageResponse = z.infer<typeof UserListingPageResponseSchema>;

export const PublicUserListingPageResponseSchema = z.object({
    users: z.array(UserProfileDetailedPublicResponseSchema),
    pagination: OpaqueCursorPaginationSchema,
});

export interface PublicUserListingPageResponse {
    users: UserProfileDetailedPublicResponse[];
    pagination: OpaqueCursorPagination;
}
